export const BUY = '/buy';
export const BUY_MARKET = `${ BUY }/:market`;
export const SELL = '/sell';
export const SELL_MARKET = `${ SELL }/:market`;
